import React from "react";
import aboutImg from "../../../assets/Home/about.png";

const About = () => {
  return (
    <div className="bg-white mt-16" id="about">
      <section className="grid grid-cols-[40%_60%] gap-16 py-20 max-w-7xl m-auto mt-6 max-sm:px-5 max-sm:grid-cols-1">
        <div>
          <img className="w-full" src={aboutImg} alt="aboutImg" />
          <p className="text-base text-primary mt-5 text-justify ">
            "Learning gives creativity, creativity leads to thinking, thinking
            provides knowledge, and knowledge makes you great."
          </p>
        </div>
        <div>
          <h1 className="text-[#2C3E50] text-2xl font-semibold mb-5 max-sm:text-lg">
            About Us
          </h1>
          <p className="text-[#4A4A4A] text-base text-justify ">
            Academia Insight Institute of Research Studies is a center of
            excellence committed to nurturing a vibrant research ecosystem for
            faculty, PhD scholars, postgraduate students, and industry
            professionals. Our mission is to bridge the gap between academic
            theory and real-world application through high-impact research,
            training, and capacity-building programs.
          </p>
          <br />
          <p className="text-[#4A4A4A] text-base text-justify ">
            We provide a robust platform for academic and industry stakeholders
            to collaborate, publish, and grow. From research methodology
            workshops and faculty development programs (FDPs) to scholarly
            writing support and industry-aligned research consultancy, Academia
            Insight empowers individuals at every stage of their academic or
            professional journey.
          </p>
          <br />
          <p className="text-[#4A4A4A] text-base text-justify ">
            With a strong focus on quality, ethics, and innovation, we support
            our members in publishing with leading journals, developing
            interdisciplinary projects, and staying ahead in the evolving
            landscape of knowledge and technology. Whether you're an academic
            aiming to enhance your research portfolio or an industry expert
            seeking evidence-based solutions, we’re here to support your
            pursuit of excellence.
          </p>
          <div className="mt-6">
            <h1 className="text-[#2C3E50] text-2xl font-semibold mb-4 max-sm:text-xl">
              Mission Statement
            </h1>
            <p className="text-[#4A4A4A] text-base text-justify ">
              At Academia Insight Institute of Research Studies, our mission is
              to empower researchers, scholars, and professionals by fostering a
              culture of high-quality, ethical, and impactful research. We aim
              to enhance academic and research skills by providing resources,
              training, and platforms that facilitate scholarly excellence and
              real-world innovation.
            </p>
          </div>
          <div className="mt-6">
            <h1 className="text-[#2C3E50] text-2xl font-semibold mb-4 max-sm:text-xl">
              Vision Statement
            </h1>
            <p className="text-[#4A4A4A] text-lg text-justify  ">
              To be a leading global institute that transforms education,
              research, and industry through collaborative knowledge creation,
              publication excellence, and continuous learning.
            </p>
          </div>
        </div>
      </section>
    </div>
  );
};

export default About;
